<template>
  <div class="product-wrapper">
    <div class="banner-container">
      <div class="banner-item">
        <img class="bg" src="../../assets/images/banner-bg.png"/>
        <div class="content">
          <div class="title">产品与服务</div>
          <div class="title">智慧场所云管理平台</div>
          <div class="subtitle"></div>
          <div class="desc">
            面向信众提供寺院快讯、导航、关注、义工报名、祈福活动、日行一善、供灯祈福、佛事供奉、活动参与等服务。<br/>
            面向宗教管理者提供站点、功能、角色、公告新闻、栏目、善款、模型、义工、事务等多方面管理。
          </div>
        </div>
      </div>
    </div>
    <div class="body-container">
      <div class="intro-container bg-gray">
        <div class="intro-con">
          <div class="content content-about">
            <div class="about-left">
              <div class="image-single">
                <!-- <img src="../../assets/images/hqms/hqms-1.png" style="width: 85%;"/> -->
              </div>
            </div>
            <div class="about-right">
              <div class="about-title" style="text-align:center;">智慧场所云管理平台</div>
              <div class="about-desc" style="margin-left:111px">
                智慧场所管理云平台是以物联网、互联网、大数据为技术支撑的综合性管理平台。平台融合线下智能硬件、线上智能互联多种渠道，以信众和宗教事务为对象，通过支付结算、信息交互、财务管理、数据可视化等多种应用服务支撑，外部对接银行金融、第三方支付、移动端等系统。
                <br/>
                平台可提供混合云环境资源的统一纳管,统一运营,统一运维服务，平台整体了宗教信息化管理的效率和服务水平，扩宽了自身的宣传渠道，减轻了自身的事务压力。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container">
        <div class="intro-item">
          <div class="intro-con">
            <div class="title">智慧场所管理平台总体架构</div>
            <!-- <div class="subtitle">
                支持多种签到（刷健康卡，医保卡，身份证）
            </div> -->
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/spmp/spmp-1.png"/>
              </div>
            </div>
          </div>
            <div class="intro-con">
            <div class="title">智慧场所平台首页</div>
            <div class="subtitle">
            面向信众提供寺院快讯、导航、关注、义工报名、祈福活动、日行一善、供灯祈福、佛事供奉、活动参与等服务。<br/>
            面向宗教管理者提供站点、功能、角色、公告新闻、栏目、善款、模型、义工、事务等多方面管理。
            </div>
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/spmp/spmp-2.jpg"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="intro-container bg-gray">
        <div class="intro-con">
          <div class="title">智慧场所管理平台优势</div>
          <div class="content content-box">
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/iv/merit-1.png"/>
                <div class="box-title">管理架构清晰</div>
                <div class="box-desc" style="text-align:center;">
                  管理层级可按市三级作战单元设置，做到穿透式线上管理，一级管二级，二级管三级，也可一级管三级。
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/iv/merit-2.png"/>
                <div class="box-title">考核功能强大</div>
                <div class="box-desc">
                  考核指标全面、灵活，管理层级可设置下一层级的考核模型；考核公开、公正，村规民约线上化、指标化，做到加减分有依据、有证据；考核对象广泛。
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/iv/merit-3.png"/>
                <div class="box-title">服务功能多样</div>
                <div class="box-desc">
                 民情反馈、投票问卷、党建活动、在线诊疗、健康申报、政策资讯、出入村卡口、在线商城、出租人员管理等十几项便民服务功能，后续根据需求还在不断添加中。
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/iv/merit-4.png"/>
                <div class="box-title">考核结果应用</div>
                <div class="box-desc">
                 以激励为主、惩戒为辅的原则，整理了26条奖惩约束清单，其中20条为激励措施。对信用考核评价优秀的居民，给予优厚的奖励政策。对信用考核评价较差的居民，给予一定的惩罚措施。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'product'
}
</script>

<style scoped lang="less">
  @import "../../assets/css/variable";
  .body-container {}
  .nav-container {
    width: @width-max;
    margin: 0 auto;
    padding: 26px 0;
    display: flex;
    align-items: center;
    .nava {
      padding: 15px;
      font-size: 16px;
      flex: 1;
      text-align: center;
    }
  }
  .intro-container .intro-con .content.content-box .box-con .box-item {
      height: 290px;
  }
  .box-desc {
      text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/product3.vue